import React from 'react'

type Props = {
    isHidden?   : boolean
    isExpanded? : boolean

    onClick     : func
}

export default function NavigationMenuItem_Arrow(props: Props) {
    const arrowClasses = Classes("arrow", {
        "hidden"    : props.isHidden,
        "closed"    : !props.isExpanded,
        "open"      : props.isExpanded,
    })

    return <div className={arrowClasses} onClick={props.onClick}/>
}
